import SupportFaq from '@/components/support-faq';

export default SupportFaq;
